import React from "react";
import "./About.css";
import Banner from "../../images/banner.jpg";
import NavBar from "../Layout/NavBar";
import Footer from "../Footer/Footer";

const About = () => {
  return (
    <div className="about-container">
      <div className="about-banner">
        <img src={Banner} alt="Flickerbound Banner" />
      </div>

      <NavBar />
      
      <div className="about-content">
        <h1 className="about-title">Flickerbound</h1>
        <h2 className="about-motto">Fueling the Imagination</h2>

        <p className="about-text">
          Flickerbound is a creative studio built around small sparks of wonder —
          fleeting ideas, half‑formed dreams, and quiet curiosity — shaped into
          something people can touch, read, color, or experience.
        </p>

        <p className="about-text">
          A <strong>flicker</strong> is the moment imagination lights up.  
          <strong> Bound</strong> means captured, shaped, and shared.
        </p>

        <p className="about-text">
          Flickerbound exists to protect imagination from being rushed,
          optimized, or outgrown. It’s a place where ideas can stay soft,
          playful, and full of possibility.
        </p>

        <h3 className="about-subtitle">The World of Flickerbound</h3>

        <p className="about-text">
          The tone of Flickerbound is imaginative, gentle, and curious — whimsical
          but grounded. Cozy, surreal, and thoughtful. It’s for children and for
          adults who still wonder. No loud hype. No forced positivity. Just
          wonder, invitation, and play.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default About;